import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import BookingStatusModal from 'common/components/booking-status-modal';
import { canUpdateBookingStatus } from 'common/helpers/canUpdateBookingStatus';

const BookingStatus = ({ id, stage, canUpdate, shouldDisplayButton }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const { t } = useTranslation();
  const buttonDisabled = !canUpdateBookingStatus(stage, canUpdate);

  return (
    <>
      <div className="booking-status">
        {shouldDisplayButton && (
          <div className="booking-status__button-wrapper">
            <Button disabled={buttonDisabled} type="primary" onClick={() => setOpenModal(true)}>
              {t('cms:cms.booking.modal.status.update_status')}
            </Button>
          </div>
        )}

        <div className="booking-status__current-status">
          <label className="booking-status__status-label">{t(`cms:cms.booking.status`)}</label>
          <div className="booking-status__status-text">
            {t(`cms:cms.booking.status.${stage?.toLowerCase()}`)}
          </div>
        </div>
      </div>
      <BookingStatusModal
        id={id}
        stage={stage}
        visible={openModal}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
};

export default BookingStatus;
